import React from 'react';
import { useNavigate } from 'react-router-dom';
import Background from '../../components/Background/Background';
import Button from '../../components/Button/Button';
import DetailSection from '../../components/DetailSection/DetailSection';
import Header from '../../components/Header/Header';
import useQuery from '../../hooks/useQuery';
import { motion } from 'framer-motion';
import fadeIn from '../../animations/fadeIn';
import { useAppSelector } from '../../hooks/useApp';
import { formatNumber } from '../../utils/numberFunctions';

const Error = () => {
  const navigate = useNavigate();
  let query = useQuery();
  const { totalPointsNeeded } = useAppSelector((state) => state.checks);
  const { isAnonymous } = useAppSelector((state) => state.auth);

  const onSignInClick = () => {
    navigate('/signin');
  };

  const onLearnMoreClick = () => {
    navigate('/about');
  };

  return (
    <>
      {query.get('type') === 'hotel' ? (
        <div className='hotels-error-backdrop' />
      ) : (
        <div className='results-backdrop' />
      )}
      {query.get('type') === 'hotel' && (
        <img
          src='/hotels-desktop-background.png'
          className='results-hotel'
          alt='Hotel'
        />
      )}
      <Background
        image={
          query.get('type') === 'flight' ? 'flight-results-full' : 'choose-page'
        }
      >
        <Header
          title={
            query.get('type') === 'flight' ? 'Flight Results' : 'Hotel Results'
          }
        />
        <div className='results-container'>
          <motion.div
            className='border-2 border-error aspect-square rounded-full w-[100px] flex justify-center items-center'
            variants={fadeIn(0.25)}
            initial='hidden'
            animate='enter'
            exit='exit'
          >
            <img src='/error.png' className='w-[50%]' alt='Error' />
          </motion.div>
          <DetailSection
            title='You still need'
            value={`${formatNumber(totalPointsNeeded)} ${
              query.get('type') === 'flight' ? 'miles' : 'points'
            }`}
          />
          <motion.p
            className='text-white text-sm'
            variants={fadeIn(0.45)}
            initial='hidden'
            animate='enter'
            exit='exit'
          >
            Fortunately, <strong>Card Curator by Odynn</strong> is the quickest
            and easiest way to make up the difference.
          </motion.p>
          <motion.div
            className='flex-1 w-full flex flex-col justify-center items-center'
            variants={fadeIn(0.55)}
            initial='hidden'
            animate='enter'
            exit='exit'
          >
            <img src='/logos/ccc-small.png' className='w-[30%]' alt='Logo' />
          </motion.div>
          <div className='flex flex-col gap-4 w-full'>
            <Button onClick={onLearnMoreClick} delay={0.5}>
              Learn More
            </Button>
            {isAnonymous && (
              <Button onClick={onSignInClick} type='secondary' delay={0.75}>
                Sign In or Sign Up
              </Button>
            )}
          </div>
        </div>
      </Background>
    </>
  );
};

export default Error;
